import { fetchAuthSession } from "@aws-amplify/auth";
import axios from "axios";

const withAuthHeaders = async (config = {}) => {
  const session = await fetchAuthSession({
    forceRefresh: true,
  });
  const userToken = session.tokens?.idToken?.toString();

  return {
    ...config,
    headers: {
      ...(config.headers || {}),
      ...(userToken ? { Authorization: userToken } : {}),
    },
  };
};

export const syncApi = {
  get: async (url, config) => axios.get(url, await withAuthHeaders(config)),
  post: async (url, data, config) =>
    axios.post(url, data, await withAuthHeaders(config)),
};
